import { EXTERNAL_PLATFORM_ALLOWED_TEMPLATE_TYPES } from '../constants/allowedTemplateTypes';
import type { ExternalPlatformMode } from '../hooks/useExternalPlatform';

export function filterExternalPlatformQuizzes<
  T extends { templateType?: string | null },
>(quizzes: T[], mode: ExternalPlatformMode): T[] {
  if (mode === 'none') return quizzes;
  const allowed = EXTERNAL_PLATFORM_ALLOWED_TEMPLATE_TYPES as readonly string[];
  return quizzes.filter(
    q => !q.templateType || allowed.includes(q.templateType),
  );
}
